import angular from 'angular';
import uiRouter from 'angular-ui-router';
import imageDetailComponent from './imageDetail.component';

let imageDetailModule = angular.module('imageDetail', [
  uiRouter
])

// .config(($stateProvider) => {
//   "ngInject";
//   $stateProvider
//   .state('imageDetail', {
//     url: '/imageDetail',
//     component: 'imageDetail'
//   });
// })

.component('imageDetail', imageDetailComponent)

.name;

export default imageDetailModule;



// WEBPACK FOOTER //
// ./client/app/common/imageDetail/imageDetail.js